module.exports = __webpack_public_path__ + "static/media/connection.abef845f.png";